import L from 'leaflet';
import util from '../util';
import map_dosha_base from './map_dosha_base';
import cityMeshTable from '../table/cityMeshTable';
/**
 * 土砂災害地図表示用クラス
 */
export default class map_dosha extends map_dosha_base {
    /**
     * コンストラクタ
     */
    constructor(mapElement, mapPos) {
        super(mapElement, mapPos);
        //  メッシュコードと市区町村名の対応テーブル
        this._cityMeshTable = undefined;
        this._meshJson = null;
    }
    /**
     * 初期化処理
     */
    Initilize() {
        setTimeout(() => {
            //  メッシュコードと市区町村名の対応テーブル
            this._cityMeshTable = new cityMeshTable();
            //  1kMeshのGeoJSONの読み込み
            this._meshJson = util.getGeoJson(util.getPath(dosya_1kmesh_env.mesh1kGeoJson));
            //
            this.setMeshLayer();
        }, 10);
    }
    /**
     * メッシュレイヤの作成（GeoJson版）
     */
    createLayer() {
        return L.geoJSON(this._meshJson, {
            style: (feature) => { return this.getMeshStyle(feature.properties.code); },
            onEachFeature: (fdata, flayer) => {
                const properties = fdata.properties;
                //  メッシュのToolTip表示
                const toolTip = this.getMeshToolTip(properties);
                flayer.bindTooltip(toolTip, {
                    offset: markerTooltipOffset,
                    direction: 'right',
                    sticky: true
                });
                //  メッシュのイベント設定
                flayer.on({
                    click: () => { this.onMeshClick(properties); },
                    mouseover: this.onMeshMouseOver,
                    mouseout: this.onMeshMouseOut,
                });
            }
        });
    }
    /**
     * マウスオーバー時イベント
     * @param e
     */
    onMeshMouseOver(e) {
        e.target.setStyle(e.target.options.overlayStyle);
        if (!L.Browser.ie && !L.Browser.edge) {
            e.target.bringToFront();
        }
    }
    /**
     * マウスアウト時イベント
     * @param e
     */
    onMeshMouseOut(e) {
        // デフォルトのスタイルに戻す
        e.target.setStyle(e.target.defaultOptions.style);
    }
    /**
     * メッシュ上に表示するToolTip
     * @param properties
     */
    getMeshToolTip(properties) {
        let mesh = properties.code;
        if (mesh && this._cityMeshTable) {
            return this._cityMeshTable.GetCityName(mesh);
        }
        else {
            return '';
        }
    }
}
